/*============================================================================*/
/*========================     PIPE MODULE     ===============================*/
/*============================================================================*/

/*
|    ======================== PIPE EVENTS TYPES =================================
|
|
|    ---------------------------- APP EVENTS -----------------------------------
|    'gh_app' - send event when element initialised
|    'gh_app_info_get' - Return app_name, app_id, app_icon
|    'gh_app_get' -
|    'gh_app_update' -
|    'gh_apps_list_get' -
|    'gh_delete_app' -
|    'gh_apps_list_update' -
|
|    ---------------------------- VIEW EVENTS -----------------------------------
|    'gh_app_views_update' -
|    'gh_app_view_get' -
|    -------------------------- ITEM EVENTS ------------------------------------
|
|    'gh_items_get' - get items_list
|    'gh_items_chunks_get' - get items splitted to chunks with specified chunk size
|    'gh_items_update' - update items_list
|
|    'gh_item_update' - item's any field value update
|    'gh_item_get' - item fields value get
|
|    -------------------------- FIELD EVENTS -----------------------------------
|
|    'gh_model_get' - get field model in field_list.
|    'gh_model_update' - update field model in field_list
|    'gh_model_delete' - delete field model from field_list and from items
|
|
|
|    'gh_models_edit' - use in 'edit_template','edit_field' and 'edit_interpretation'
|                      actions
|    'gh_models_get' - get field_model list.
|
|
|
|    'gh_value_update' - update field value in item
|    'gh_value_get' - get field value
|    'gh_interpreted_value_get' - get field interpretation
|    'gh_value_set' - setter of field value
|
*/

import { checkParams, createId } from "./utils.js";

export class PipeService {
  constructor() {
    this.subscribers = {};
    this.messageBox = {}; 
  }

  //============================== ON PIPE ====================================//
  /*----------------------------------------------------------------------------
       |  Params:
       |    'type' - String (require). type of event ('gh_field_update', ........)
       |          from event list or maybe 'gh_field_update gh_field_value_update'
       |    'destination' - Object (require).
       |      {
       |        app_id: '',
       |        item_id: ''
       |        field_id: ''
       |      }
       |    'fn' - Function (require). callback function
       |    'scope' - Scope
       |------------------------------------------------------------------------------*/

  on(types, destination, fn) {
    if (checkParams(types, destination, fn)) {
      types
        .split(" ")
        .map((type) => {
          return type + ":" + createId(destination);
        })
        .forEach((typeWithId) => {
          if (!this.subscribers[typeWithId]) {
            this.subscribers[typeWithId] = new Set();
          }

          this.subscribers[typeWithId].add(fn);

          //checking for messeges those were sent before subscription created
          this.checkMessageBox(typeWithId);
        });
    }
    return this;
  }

  //============================== EMIT PIPE ====================================//
  /*------------------------------------------------------------------------------
       |  Params:
       |    'type' - String (require). type of event ('gh_field_update', ........)
       |            from eventlist
       |    'destination' - Object (require).
       |        {
       |          app_id: '',
       |          item_id: ''
       |          field_id: ''
       |        }
       |    'value' - Any (require). Emiter value to  subscribers
       |-------------------------------------------------------------------------------*/

  emit(types, destination, value, params) {
    types.split(" ").forEach((type) => {
      const listenerName = type + ":" + createId(destination);
      let toBeRemovedState = false;

      if (this.subscribers[listenerName]) {
        
        // if subscribers list is empty we put message to messageBox
        if (this.subscribers[listenerName].size == 0){
          this.messageBox[listenerName] = [types, destination, value, params, toBeRemovedState];
          return this;
        }

        // sending messege to subscribers
        this.subscribers[listenerName].forEach(function (fn) {
          fn(null, value, params);
        });

      }else {
        // if there no subscribers list we put message to messageBox
        this.messageBox[listenerName] = [types, destination, value, params, toBeRemovedState];
      }
    });
    return this;
  }

  //============================== ON ROOT PIPE ====================================//
  /*---------------------------------------------------------------------------------
       |  Params:
       |    'type' - String (require). type of event ('gh_field_update', ........)
       |          from event list or maybe 'gh_field_update gh_field_value_update'
       |    'destination' - Object (require).
       |      {
       |        app_id: '',
       |        item_id: ''
       |        field_id: ''
       |      }
       |    'fn' - Function (require). callback function
       |---------------------------------------------------------------------------------*/

  onRoot(type, destination, fn) {
    return this.on(type, destination, fn);
  }

  //=========================== DELETE LISTENER =================================//
  /*-------------------------------------------------------------------------------
       |  Params:
       |    'type' - String (require). type of event ('gh_field_update', ........)
       |            from eventlist
       |    'destination' - Object (require).
       |        {
       |          app_id: '',
       |          item_id: ''
       |          field_id: ''
       |        }
       |--------------------------------------------------------------------------------*/

  destroy(types, destination, func) {
    types.split(" ").forEach((type) => {
      const listenerName = type + ":" + createId(destination);
      
      //if we pass a function then we remove just function in subscriber property
      if (this.subscribers[listenerName] && func) {
        this.subscribers[listenerName].delete(func);
      }

      //if we are not passing a function then we remove a subscriber property
      if (this.subscribers[listenerName] && !func) {
        delete this.subscribers[listenerName];
      }
    });

    return this;
  }

  

  //============================== MESSAGE BOX ====================================//
  /*---------------------------------------------------------------------------------
       |  If emitting event started erlier then subscriber apears then we save it to the MessageBox
       |  After subscriber is created we update check MessageBox for encomming messendges
       |
       |---------------------------------------------------------------------------------*/

      checkMessageBox(listenerName) {

        //Here we delete all messages those are marked as "to be removed"
        this.cleanMesssageBox();

        if (this.messageBox[listenerName]) {

          //-- Emiting messages from the MessageBox
          //We use timeout to emit message after subscriber is created
          setTimeout(() => {
            if(this.messageBox[listenerName]) {
              this.emit(...this.messageBox[listenerName]);

              //we mark message after it was readed as "to be removed" to remove it in next itration 
              this.messageBox[listenerName][4] = true;
            }
          }, 0);
        }
      }


      /*-------- CLEAN MESSAGE BOX -----------*/
      // This method delete all messages those are marked as "to be deleted"
      // The thing is that we can't remove message in the same iteration that is wy we mark them as "to be removed
      // and then will remove them in the second iteration just before checking the MessageBox
      cleanMesssageBox(){
        for (let listenerName in this.messageBox) {
          if(this.messageBox[listenerName][4]){
            delete this.messageBox[listenerName];
          }
        }
      }
}
